module.exports = __webpack_public_path__ + "img/tarj1-1.33a5ed0e.png";